import React, {useEffect, useMemo, useState} from 'react';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {roomSelector} from '../../../../../store/selectors/roomRunFile.selectors';

function ViewerWaitingLabel(): JSX.Element {
    const room = useSelector(roomSelector);
    const {t, i18n} = useTranslation();

    const [now, setNow] = useState(() => Date.now());
    useEffect(() => {
        if (!room.startTime) return undefined;
        const interval = setInterval(() => setNow(Date.now()), 1000);
        return () => clearInterval(interval);
    }, [room.startTime]);

    const startsAtLabel = useMemo(() => {
        if (!room.startTime) return null;
        const startMs = new Date(room.startTime).getTime();
        if (Number.isNaN(startMs)) return null;

        const remaining = startMs - now;
        if (remaining <= 0) return null;

        if (remaining > 60 * 60 * 1000) {
            const locale = i18n.language?.toLowerCase().startsWith('hr') ? 'hr-HR' : 'en-US';
            const time = new Date(startMs).toLocaleString(locale, {dateStyle: 'medium', timeStyle: 'short'});
            return t('roomSchedule.startsAt', {time});
        }

        if (remaining <= 60 * 1000) {
            return t('roomSchedule.startingSoon');
        }

        return t('roomSchedule.startsInMinutes', {minutes: Math.ceil(remaining / 60000)});
    }, [room.startTime, now, i18n.language, t]);

    return <>{startsAtLabel || t('lobby.viewer.waiting')}</>;
}

export default ViewerWaitingLabel;
